const asText = (value) =>
  value === undefined || value === null ? "" : String(value).trim();

export const stripIdentificacionVisual = (value) =>
  asText(value).replace(/\D/g, "");

export const formatIdentificacionVisual = (value) => {
  const raw = asText(value);
  if (!raw) return "";

  // PersonaId values can include letters (for example: E1034...), keep them unchanged.
  if (/[a-zA-Z]/.test(raw)) return raw;

  const digits = stripIdentificacionVisual(raw);
  if (!digits) return raw;
  if (digits.length <= 4) return digits;
  if (digits.length <= 8) return `${digits.slice(0, 4)}-${digits.slice(4)}`;
  return `${digits.slice(0, 4)}-${digits.slice(4, 8)}-${digits.slice(8)}`;
};

export const stripTelefonoVisual = (value) =>
  asText(value).replace(/\D/g, "");

export const formatTelefonoVisual = (value) => {
  const digits = stripTelefonoVisual(value);
  if (!digits) return "";
  if (digits.length <= 4) return digits;
  if (digits.length <= 8) return `${digits.slice(0, 4)}-${digits.slice(4)}`;
  return `${digits.slice(0, 4)}-${digits.slice(4, 8)}-${digits.slice(8)}`;
};
